import JsBarcode from "jsbarcode";

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const barcodeSvg = (value) => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  JsBarcode(svg, String(value), {
    format: "CODE128",
    displayValue: true,
    // These labels are intentionally wide.  Narrow, compressed bars are
    // difficult for a POS scanner to read from both paper and a screen.
    fontSize: 12,
    textMargin: 3,
    margin: 8,
    height: 42,
    width: 1.5,
  });
  return svg.outerHTML;
};

export const printBarcodeLabelBatch = (labels) => {
  if (!labels.length) throw new Error("No barcode labels are available to print.");
  const popup = window.open("", "_blank");
  if (!popup) throw new Error("Allow pop-ups to print barcode labels.");
  popup.opener = null;
  const html = labels.map((label) => `<article class="label"><div class="copy"><strong>CHARMS COLLECTIONS PVT. LTD.</strong><span>PRODUCT : ${escapeHtml(label.product)}</span><span>BRAND : ${escapeHtml(label.brand)}</span><span>STYLE NO. : ${escapeHtml(label.style)}</span><span>SIZE : ${escapeHtml(label.size)}</span><b>MRP : ${label.mrp == null ? "—" : `₹${Number(label.mrp).toFixed(2)}`}</b></div><div class="barcode">${barcodeSvg(label.barcode)}</div></article>`).join("");
  popup.document.write(`<!doctype html><html><head><title>Barcode labels</title><style>
    /* CHARMS two-column A4 sticker sheet: 2 × 10 labels. Keep print scale at 100%. */
    @page { size:A4 portrait; margin:0; }
    *{box-sizing:border-box}
    html,body{width:210mm;margin:0;padding:0;font-family:Arial,sans-serif;color:#000;background:#fff}
    .sheet{width:210mm;min-height:297mm;display:grid;grid-template-columns:repeat(2,104.5mm);grid-auto-rows:28.8mm;column-gap:1mm;row-gap:1mm;align-content:start}
    .label{width:104.5mm;height:28.8mm;border:.18mm solid #111;border-radius:1.2mm;padding:1.5mm;display:grid;grid-template-columns:minmax(0,1fr) 42mm;gap:1.2mm;overflow:hidden;page-break-inside:avoid;break-inside:avoid}
    .copy{display:flex;flex-direction:column;min-width:0;font-size:6.6pt;font-weight:600;line-height:1.12;white-space:nowrap;overflow:hidden}
    .copy strong{font-size:6.5pt;margin-bottom:.65mm;letter-spacing:-.02em}.copy span{overflow:hidden;text-overflow:ellipsis}.copy b{margin-top:auto;font-size:9.8pt;line-height:1}
    .barcode{align-self:center;width:42mm;padding:.4mm 0;background:#fff}.barcode svg{width:42mm;height:auto;display:block}
    @media print{html,body{width:210mm;height:297mm;margin:0;padding:0}.sheet{margin:0}.label{print-color-adjust:exact;-webkit-print-color-adjust:exact}}
    @media screen{body{padding:8mm;background:#e5e7eb}.sheet{margin:0 auto;background:#fff;box-shadow:0 1mm 5mm #0004}}
  </style></head><body><main class="sheet">${html}</main><script>window.onload=()=>window.print()</script></body></html>`);
  popup.document.close();
};

export function printBarcodeLabels(receiptItems) {
  const labels = receiptItems.flatMap((item) => {
    const quantity = Math.min(500, Math.max(0, Math.floor(Number(item.quantityAccepted || 0))));
    const barcode = item.variant?.barcode;
    if (!barcode || quantity === 0) return [];

    const details = {
      product: item.variant?.product?.name || "Product",
      brand: item.variant?.product?.brand?.name || "—",
      style: item.variant?.product?.productCode || item.variant?.sku || "—",
      size: item.variant?.size?.name || "—",
      mrp: item.mrp ?? item.inventoryLot?.mrp ?? null,
      barcode,
    };

    return Array.from({ length: quantity }, () => details);
  });

  if (!labels.length) throw new Error("This GRN has no accepted items with a barcode to print.");
  printBarcodeLabelBatch(labels);
}

export function printVariantBarcodeLabels({ product, variant, mrp, quantity }) {
  if (!variant?.barcode) throw new Error("This variant does not have a barcode yet.");
  const count = Math.min(500, Math.max(1, Math.floor(Number(quantity) || 1)));
  printBarcodeLabelBatch(Array.from({ length: count }, () => ({ product: product?.name || "Product", brand: product?.brand?.name || "—", style: product?.productCode || variant.sku || "—", size: variant.size?.name || "—", mrp, barcode: variant.barcode })));
}
